enum RefundType {
  FULL_PULLBACK = 'Full Pullback',
  PRO_RATED = 'Pro Rated',
  UNTOUCHED = 'Untouched',
}
export default RefundType;
export type VerifyProductType = Utils.VerifyExtends<Model.Enum.RefundType, Utils.ValueOf<typeof RefundType>>;
